import React from "react";
import AppIcon from "@/components/AppIcon.jsx";
import { SERVICE_PRICE_CURRENCY_OPTIONS } from "./servicePriceCurrency.js";

export default function CurrencyCodeDropdown({ value, onChange, disabled = false, onOpenChange, alignWithField = false, chevronSrc = "/icons/appointments/dashboard/Show_less.svg" }) {
  const [open, setOpen] = React.useState(false);
  const menuRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!menuRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  React.useEffect(() => {
    onOpenChange?.(open);
  }, [onOpenChange, open]);

  return (
    <div ref={menuRef} className="relative shrink-0">
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        disabled={disabled}
        className={`inline-flex min-w-[68px] cursor-pointer items-center justify-between gap-1 rounded-[10px] py-1 text-left text-body-large text-on-surface-var hover:bg-[rgba(24,50,119,0.06)] disabled:cursor-not-allowed disabled:opacity-38 ${alignWithField ? "px-0" : "px-2"}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Currency"
      >
        <span>{value}</span>
        <img
          src={chevronSrc}
          alt=""
          className={`h-[18px] w-[18px] transition-transform ${open ? "rotate-180" : ""}`}
          draggable="false"
        />
      </button>

      {open ? (
        <div
          className="currency-code-dropdown-menu absolute left-0 top-full z-20 mt-2 w-[148px] overflow-hidden rounded-[12px] border border-[rgba(15,23,42,0.08)] bg-[rgb(var(--clr-surface-cont-highest))] shadow-[0px_12px_24px_-10px_rgba(29,79,215,0.10),0px_6px_12px_-4px_rgba(26,27,35,0.08)]"
          role="listbox"
          aria-label="Currency"
        >
          <div className="max-h-[280px] overflow-y-auto py-1">
            {SERVICE_PRICE_CURRENCY_OPTIONS.map((currency) => {
              const selected = currency === value;
              return (
                <button
                  key={currency}
                  type="button"
                  role="option"
                  aria-selected={selected}
                  onClick={() => {
                    onChange(currency);
                    setOpen(false);
                  }}
                  className="flex w-full items-center gap-3 px-4 py-2.5 text-left text-body-medium text-on-surface hover:bg-[rgba(24,50,119,0.06)]"
                >
                  <span className="grid h-4 w-4 place-items-center text-primary">
                    {selected ? <AppIcon name="Check" size={16} /> : null}
                  </span>
                  <span className="flex-1">{currency}</span>
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}
